// 0-100 across the technical 0-9 scale. 0 stays 0, 9 becomes 100.
export const toDisplayScore = (score: number): number =>
	Math.min(100, Math.max(0, Math.round((score / 9) * 100)));

// The previous score, rounded the same way as the current one. Subtracting the
// two displayed numbers is the change the pill shows.
export const toDisplayPreviousScore = (score: number, delta: number): number =>
	toDisplayScore(score - delta);

export const toDisplayDelta = (score: number, delta: number): number =>
	toDisplayScore(score) - toDisplayPreviousScore(score, delta);

export const formatDisplayScore = (score: number): string => String(Math.round(score));
